// Utility functions for Product Showcase

// Extract clean category names from Categories field
export const extractCategories = (products) => {
  const categorySet = new Set();
  
  products.forEach(product => {
    if (product.Categories) {
      // Split multiple categories and extract clean category names
      const categoryList = product.Categories.split(',').map(cat => {
        const cleanCat = cat.trim();
        // Extract the description part after the code
        const match = cleanCat.match(/^[^ ]+ (.+)$/);
        return match ? match[1].trim() : cleanCat;
      });
      categoryList.forEach(cat => {
        if (cat && cat !== '') categorySet.add(cat);
      });
    }
  });
  
  return Array.from(categorySet).sort();
};

// Filter products by category and search term
export const filterProducts = (products, selectedCategory, searchTerm) => {
  return products.filter(product => {
    // Filter by category (supports multiple categories)
    const categoryMatch = selectedCategory === 'all' || 
      (product.Categories && product.Categories.includes(selectedCategory));
    
    // Filter by search term (searches in name and Categories)
    const searchMatch = searchTerm === '' || 
      product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.Categories?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description?.toLowerCase().includes(searchTerm.toLowerCase());
    
    return categoryMatch && searchMatch;
  });
};

// Handle image errors with fallback
export const handleImageError = (event) => {
  event.target.style.display = 'none';
  if (event.target.nextSibling) {
    event.target.nextSibling.style.display = 'flex';
  }
};

// Get image source with fallback
export const getImageSrc = (url) => {
  if (typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  
  // Return public folder URL as-is (format: /products/{filename}.webp)
  return trimmed;
};

// Format product image alt text
export const getImageAlt = (product) => {
  return product.name || 'Product image';
};

// Check if product has gift eligibility
export const hasGiftEligibility = async (productId) => {
  try {
    const { productService } = await import('../services/productService');
    const giftData = await productService.getGiftData(productId);
    return Object.keys(giftData).length > 0;
  } catch (error) {
    console.error('Error checking gift eligibility:', error);
    return false;
  }
};

// Generate unique cart item key
export const generateCartItemKey = (product) => {
  return product.code ? String(product.code).trim() : String(product.id);
};

// Validate product stock (showcase mode - no stock tracking)
export const validateStock = (quantity, stock) => {
  // In showcase mode, we don't enforce stock limits
  return Math.max(1, quantity);
};

// Format display text for showcase
export const formatDisplayText = (text, maxLength = 100) => {
  if (!text) return '';
  return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
};
